import React, { useMemo, useState } from "react";

import { FlamebearerCall } from "@platformsh/observability-graph/ContinuousProfiling";

import { debounce } from "ds/utils/debounce";

import * as S from "./ComparisonFlamebearer.styles";
import ComparisonFlamebearerGraph from "./graph/ComparisonFlamebearerGraph";

const ComparisonFlamebearer = () => {
  const [highlightedCall, setHighlightedCall] = useState<
    FlamebearerCall | undefined
  >(undefined);
  const handleCallHighlighted = useMemo(() => {
    return debounce(setHighlightedCall);
  }, []);

  return (
    <S.Layout>
      <S.Row>
        <S.Cell>
          <ComparisonFlamebearerGraph
            highlightedCall={highlightedCall}
            onCallHighlighted={handleCallHighlighted}
            side="A"
          />
        </S.Cell>
        <S.Cell>
          <ComparisonFlamebearerGraph
            highlightedCall={highlightedCall}
            onCallHighlighted={handleCallHighlighted}
            side="B"
          />
        </S.Cell>
      </S.Row>
    </S.Layout>
  );
};

export default ComparisonFlamebearer;
